import { render, staticRenderFns } from "./zhongqiubianlian.vue?vue&type=template&id=207af5a4&scoped=true&"
import script from "./zhongqiubianlian.vue?vue&type=script&lang=js&"
export * from "./zhongqiubianlian.vue?vue&type=script&lang=js&"
import style0 from "./zhongqiubianlian.vue?vue&type=style&index=0&id=207af5a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207af5a4",
  null
  
)

export default component.exports